module.exports = __webpack_public_path__ + "static/media/1.de9fa67d.jpg";